import { ExternalLinkIcon } from '@chakra-ui/react';
export const NAV_ITEMS = [
    {
      label: "README",
      path: "/",
      type: "internal",
      scroll: "readme"
    },
    {
      label: "PROJECTS",
      path: "/projects",
      type: "internal",
      scroll: "projects"
    //   underConstruction: true,
    },
    {
      label: "CONTACT",
      path: "/contact",
      type: "internal",
      scroll: "contact"
    },
    
  
  ];
  
  